module.exports = __webpack_public_path__ + "img/pan_head_sku.prt.db331672.jpg";